<div class="row" id="divArticleDataList">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">

        <div class="col-sm-12" id="divMainFilter" style="display:none;">
          <div class="row">
            <div class="col-sm-2">
              <label>From</label>
              <input type="date" name="DOB" class="form-control float-right" id="Txt_FromDate" autocomplete="off">
            </div>
            <div class="col-sm-2">
              <label>To</label>
              <input type="date" name="DOB" class="form-control float-right" id="Txt_ToDate" autocomplete="off">
            </div>
            <div class="col-sm-2">
              <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Get" id="btnLoadList" (click)="LoadDataList()">Search</button>
              <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="ResetFilter()" style="margin-left:10px">Reset</button>
            </div>
          </div>
        </div>

        <app-articlemeta></app-articlemeta>

        <table #dataTable class="display" style="width:100%"></table>
        <button type="button" id="btnPopupDT" class="btn btn-block btn-primary float-sm-right" (click)="showInfoPopUp()" style="display:none">POP-UP</button>


      </div>
    </div>
  </div>
</div>
